import * as React from "react";
const SvgFiBrandsPfizer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-pfizer_svg__a)">
      <path d="M19.68 19.337 18.412 24C9.428 23.452 0 19.063 0 15.463c0-.267.058-.577.174-1.035l.003-.014 1.091-4.025c.789-2.948 5.52-3.874 12-3.051L12 12c-4.483-.54-8.001-.263-10.027.69 2.409 3.016 10.123 6.104 17.707 6.647" />
      <path d="M24 8.537c0 .411-.137.925-.412 1.92l-.857 3.154c-.79 2.948-5.52 3.874-12 3.051L12 12c4.485.54 8.003.265 10.028-.689C19.622 8.295 11.906 5.206 4.32 4.663L5.588 0C14.572.548 24 4.937 24 8.537" />
    </g>
    <defs>
      <clipPath id="fi-brands-pfizer_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsPfizer;
